import { useState, useRef, useEffect } from 'react';

// useElementObserver - this is a stateful hook that has a stateful variable and a ref.
// usage - use this hook to get information from an html element on the page where you need information on the element between renders
// i.e. getting the width of the container element to be used in the popoversheet.

const useElementObserver = () => {
  const [element, setElement] = useState(null);
  const elementRef = useRef(null);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (elementRef.current) {
        setElement(elementRef.current);
      }
    });
    if (elementRef.current) {
      observer.observe(elementRef.current, {
        attributes: true,
        childList: true,
        subtree: true
      });
      setElement(elementRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return [element, elementRef];
};
export default useElementObserver;